import { FC, useEffect, useMemo, useState } from 'react';
import styles from './index.module.less';
// import V2LineChart from '@/common/components/Charts/V2LineChart';
import { useMethods } from '@lhb/hook';
import { beautifyThePrice, floorKeep, getKeysFromObjectArray, isNotEmpty, isNotEmptyAny, percentValueFormatter } from '@lhb/func';
import V2Tabs from '@/common/components/Data/V2Tabs';
import V2Title from '@/common/components/Feedback/V2Title';
import V2DetailGroup from '@/common/components/Feedback/V2DetailItem/Group';
import { Col, Row } from 'antd';
import V2DetailItem from '@/common/components/Feedback/V2DetailItem';
import V2PieChart from '@/common/components/Charts/V2PieChart';
import MachineInfo from './MachineInfo';
import { AnaStatus } from '../../ts-config';
import dayjs from 'dayjs';
import { deviceTaskAnalysisDetail, deviceTaskAnalysisDetailDemo } from '@/common/api/passengerflowcount';
import IconFont from '@/common/components/IconFont';
import SpotLines from './SpotLines';

/**
 * @Description 客流计数 - 任务详情抽屉主体内容
 */
const SpotDetailDrawerMain: FC<{
  spotDetail, isDemonstrate
  /** 是否禁用（分享时禁用操作） */
  disabled?: boolean;
}> = ({ spotDetail, isDemonstrate, disabled }) => {
  // const [xAxisDataLine, setXAxisDataLine] = useState<Array<string>>([]);
  // const [seriesDataLine, setSeriesDataLine] = useState<any>({});
  const [tabItems, setTabItems] = useState<any>([]);
  const [tabActive, setTabActive] = useState<string>('');
  const [sexPieChartData, setSexPieChartData] = useState<any>([]);
  const [agePieChartData, setAgePieChartData] = useState<any>([]);
  const [taskAnalysisDetail, setTaskAnalysisDetail] = useState<any>({}); // 任务分析详情

  const imgArr:{url:string}[] = useMemo(() => {
    if (taskAnalysisDetail?.cameraList && taskAnalysisDetail.cameraList?.length) {
      return getKeysFromObjectArray(taskAnalysisDetail.cameraList, 'picUrl').filter(itm => !!itm).map((item: any) => ({ url: item }));
    }
    return [];
  }, [taskAnalysisDetail?.cameraList]);

  useEffect(() => {
    if (isNotEmptyAny(spotDetail)) {
      methods.getTabItems();
    }
  }, [spotDetail]);

  useEffect(() => {
    tabActive && methods.getDeviceTaskAnalysisDetail(tabActive);
  }, [tabActive]);

  const methods = useMethods({
    // getLineChartData() {
    //   if (taskAnalysisDetail.lineChart?.length) {
    //     const xAxisData: any = [];
    //     const data: any = [];
    //     taskAnalysisDetail.lineChart.forEach((res) => {
    //       xAxisData.push(res.name);
    //       data.push(Number(res.value));
    //     });
    //     setXAxisDataLine(xAxisData);
    //     setSeriesDataLine({
    //       name: taskAnalysisDetail.date,
    //       unit: '人',
    //       data
    //     });
    //   }
    // },
    getTabItems() {
      if (spotDetail.tasks) {
        const _tabItems = spotDetail.tasks.map(item => {
          return {
            label: `${dayjs(item.date).format('YYYY.MM.DD')}(${methods.getDateFormat(item.date)})`,
            key: item.id,
          };
        });
        setTabItems(_tabItems);
        setTabActive(_tabItems?.[0].key);
      }
    },
    getPieChartData() {
      const sexPieData = [
        { value: taskAnalysisDetail.passbyMale, name: '男' },
        { value: taskAnalysisDetail.passbyFemale, name: '女' }
      ];
      const agePieData = [
        { value: taskAnalysisDetail.passbyChild, name: '儿童' },
        { value: taskAnalysisDetail.passbyYouth, name: '青年' },
        { value: taskAnalysisDetail.passbyMiddle, name: '中年' },
        { value: taskAnalysisDetail.passbyOlder, name: '老年' },
      ];
      setSexPieChartData(sexPieData);
      setAgePieChartData(agePieData);
    },
    dateShow() {
      if (taskAnalysisDetail.duration) {
        const minute = Math.floor(taskAnalysisDetail.duration / 60);
        if (minute > 60) {
          return `${Math.floor(minute / 60)}小时${minute % 60}分钟`;
        } else {
          return `${minute}分钟`;
        }
      } else {
        return '-';
      }
    },
    getDateFormat(date) {
      const daysOfWeek = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];
      const dayOfWeek = new Date(date).getDay();
      return daysOfWeek[dayOfWeek];
    },
    getDeviceTaskAnalysisDetail(id) {
      setSexPieChartData([]);
      setAgePieChartData([]);
      const api = isDemonstrate ? deviceTaskAnalysisDetailDemo : deviceTaskAnalysisDetail;
      api(id).then((res) => {
        setTaskAnalysisDetail({ ...res.data || {} });
        // methods.getLineChartData();
        methods.getPieChartData();
      });
    },
    onRefresh() {
      tabActive && methods.getDeviceTaskAnalysisDetail(tabActive);
    },
    returnValue(value, total) {
      const percent = percentValueFormatter(value, total);
      if (isNotEmpty(percent)) {
        return `${percent}%`;
      }
      return '-';
    },
    getSpan(list = [], parentLength) {
      if (parentLength === 1) {
        if (list.length === 1) {
          return 24;
        } else if (list.length === 2) {
          return 12;
        } else if (list.length === 3) {
          return 8;
        } else {
          return 6;
        }
      } else {
        if (list.length === 1) {
          return 24;
        } else {
          return 12;
        }
      }
    }
  });

  const showOldFlow = useMemo(() => {
    return taskAnalysisDetail.passbyGender && !!sexPieChartData?.length;
  }, [taskAnalysisDetail, sexPieChartData]);

  // 仅针对二轮车和提袋客流
  const newFlowStatisticsKeys = useMemo(() => {
    const keys: any[] = [];
    const twoWheelVehiclePeriods: any[] = []; // 二轮车机位列表
    const shoppingCountPeriods: any[] = []; // 提袋机位列表
    if (taskAnalysisDetail.timePeriods?.length && taskAnalysisDetail.timePeriods[0].cameraFlowList?.length) {
      taskAnalysisDetail.timePeriods[0].cameraFlowList.map((item) => {
        twoWheelVehiclePeriods.push({
          name: item.cameraName,
          num: 0,
          unit: '人',
        });
        shoppingCountPeriods.push({
          name: item.cameraName,
          num: 0,
          unit: '人',
        });
      });
      taskAnalysisDetail.timePeriods.map(parent => {
        parent.cameraFlowList.map((child, index) => {
          twoWheelVehiclePeriods[index].num = Math.round((child.twoWheelVehicle || 0) + twoWheelVehiclePeriods[index].num);
          shoppingCountPeriods[index].num = Math.round((child.shoppingCount || 0) + shoppingCountPeriods[index].num);
        });
      });
    }
    if (taskAnalysisDetail.passbyTwoWheelVehicle) {
      keys.push({
        id: 'twoWheel',
        unit: '人',
        name: '二轮车',
        num: taskAnalysisDetail.twoWheelVehicleTotal,
        list: twoWheelVehiclePeriods,
        icon: 'asset-pc-keliu_erlunche'
      });
    }
    if (taskAnalysisDetail.shoppingCount) {
      keys.push({
        id: 'shopping',
        unit: '人',
        name: '提袋数',
        num: taskAnalysisDetail.shoppingCountTotal,
        list: shoppingCountPeriods,
        icon: 'asset-pc-keliu_tidaishu'
      });
    }
    return keys;
  }, [taskAnalysisDetail]);

  const showFlowStatistics = useMemo(() => {
    if (showOldFlow) {
      return true;
    }
    if (newFlowStatisticsKeys.length) {
      return true;
    }
    return false;
  }, [sexPieChartData, taskAnalysisDetail]);

  return (
    <div className={styles.mainContainer}>
      <SpotLines id={spotDetail?.id}/>
      <div className={styles.dateBasicInfo}>
        <V2Tabs items={tabItems} activeKey={tabActive} onChange={(val) => {
          setTabActive(val);
        }} />
        <div className={styles.basicContent}>
          <V2Title divider type='H2' text='基本信息' className='mt-16'/>
          <V2DetailGroup>
            <Row gutter={16}>
              <Col span={12}>
                <V2DetailItem label='任务状态' value={ taskAnalysisDetail.anaStatusName } />
              </Col>
              <Col span={12}>
                <V2DetailItem label='设备ID' value={ taskAnalysisDetail.serialNums ? taskAnalysisDetail.serialNums?.join('、') : '-' }/>
              </Col>
              <Col span={12}>
                <V2DetailItem label='拍摄时间' value={[taskAnalysisDetail.start, taskAnalysisDetail.end].filter(Boolean).join('-')} />
              </Col>
              <Col span={12}>
                <V2DetailItem label='拍摄时长' value={ taskAnalysisDetail.duration ? methods.dateShow() : '-' } />
              </Col>
              <Col span={12}>
                <V2DetailItem label='分析时段' value={ taskAnalysisDetail.analysisPeriod } />
              </Col>
              <Col span={12}>
                <V2DetailItem label={
                  <div className={styles.picUrl}>
                    <div>分析区域</div>
                    {!taskAnalysisDetail.hasDrawFrame && <div className={styles.picUrlTips}> <IconFont iconHref='pc-common-icon-ic_warning'/>请尽快绘制分析区域，以免影响正常分析</div>}
                  </div>
                }type='images' assets={ imgArr} />
              </Col>
            </Row>
          </V2DetailGroup>
          {/* 已分析展示 */}
          {taskAnalysisDetail?.anaStatus === AnaStatus.ANALYSIS_COMPLETED && <>
            <V2Title divider type='H2' text='客流统计' className='mt-24' />
            <Row gutter={16} className={styles.sexAgePieChartWrap}>
              <Col span={12}>
                <div className={styles.pieChartLabel}>人数类型</div>
                <div className={styles.sexPieChart}>
                  <div className={styles.sexNew}>
                    <div className={styles.sexNewInner}>
                      <div className={styles.flowTotalCount}>
                        <div className={styles.flowTotalCountLabel}>过店总人数</div>
                        <div className={styles.flowTotalCountValue}>{ taskAnalysisDetail.anaStatus === 3 ? <><span>{ beautifyThePrice(taskAnalysisDetail.passbyCount, ',', 0) }</span>人</> : '-' }</div>
                        <img className={styles.flowTotalCountIcon} src={`${process.env.STATIC_RES_DOMAIN}/project-custom/locationpc/flow/flow_icon@2x-new.png`} />
                      </div>
                      {
                        showFlowStatistics && (
                          <Row gutter={[12, 10]}>
                            {
                              taskAnalysisDetail.passbyGender && !!sexPieChartData?.length && (
                                <>
                                  <Col span={12}>
                                    <div className={styles.flowItem}>
                                      <div className={styles.flowParentWrapper}>
                                        <div className={styles.flowItemTop}>
                                          {
                                            methods.returnValue(sexPieChartData[0].value, sexPieChartData.reduce((total, item) => {
                                              return floorKeep(total, item.value || 0, 2);
                                            }, 0))
                                          }
                                        </div>
                                        <div className={styles.flowItemBottom}>男性</div>
                                        <IconFont iconHref='asset-pc-keliu_nanshi' className={styles.flowIcon} />
                                      </div>
                                    </div>
                                  </Col>
                                  <Col span={12}>
                                    <div className={styles.flowItem}>
                                      <div className={styles.flowParentWrapper}>
                                        <div className={styles.flowItemTop}>
                                          {
                                            methods.returnValue(sexPieChartData[1].value, sexPieChartData.reduce((total, item) => {
                                              return floorKeep(total, item.value || 0, 2);
                                            }, 0))
                                          }
                                        </div>
                                        <div className={styles.flowItemBottom}>女性</div>
                                        <IconFont iconHref='asset-pc-keliu_nvshi' className={styles.flowIcon} />
                                      </div>
                                    </div>
                                  </Col>
                                </>
                              )
                            }
                            {
                              newFlowStatisticsKeys?.map((item) => (
                                <Col span={newFlowStatisticsKeys.length === 2 ? 12 : 24}>
                                  <div className={styles.flowItem}>
                                    <div className={styles.flowParentWrapper}>
                                      <div className={styles.flowItemTop}>
                                        <div className={styles.flowItemTopNum}>{item.num}</div>
                                        <div className={styles.flowItemTopUnit}>{item.unit}</div>
                                      </div>
                                      <div className={styles.flowItemBottom}>{item.name}</div>
                                      <IconFont iconHref={item.icon} className={styles.flowIcon} />
                                    </div>
                                    {
                                      !!item.list.length && item.list.length > 1 && (
                                        <Row gutter={[6, 6]} className={styles.flowChildWrapper}>
                                          {
                                            item.list.map(child => (
                                              <Col span={methods.getSpan(item.list, newFlowStatisticsKeys.length)}>
                                                <div className={styles.flowChild}>
                                                  <div className={styles.flowChildTop}>
                                                    <div className={styles.flowChildTopNum}>{child.num}</div>
                                                    <div className={styles.flowChildTopUnit}>{child.unit}</div>
                                                  </div>
                                                  <div className={styles.flowChildBottom}>{child.name}</div>
                                                </div>
                                              </Col>
                                            ))
                                          }
                                        </Row>
                                      )
                                    }
                                  </div>
                                </Col>
                              ))
                            }
                          </Row>
                        )
                      }
                    </div>
                  </div>
                </div>
              </Col>
              { taskAnalysisDetail.passbyAge && !!agePieChartData?.length && (
                <Col span={12}>
                  <div className={styles.pieChartLabel}>年龄分布</div>
                  <div className={styles.sexPieChart2}>
                    <div className={styles.sexPieChart2Place}></div>
                    <V2PieChart
                      type='circle'
                      height={200}
                      seriesData={[{
                        data: agePieChartData,
                        unit: '人',
                      }]}
                      config={{
                        legend: {
                          formatter: (name: string) => {
                            const data = agePieChartData || [];
                            const item = data.find(item => item.name === name);
                            const newName = name?.length > 6 ? name.slice(0, 6) + '...' : name;
                            if (isNotEmptyAny(item)) {
                              let per: any = item.value;
                              if (per) {
                                const percent = percentValueFormatter(item.value, data.reduce((total, item) => {
                                  if (item.value) {
                                    total = floorKeep(item.value, total, 2);
                                  }
                                  return total;
                                }, 0));
                                per = `${percent}%`;
                              } else {
                                per = `0%`;
                              }
                              return `${newName} ${per} | ${item.value || 0}`;
                            }
                            return newName;
                          }
                        }
                      }}
                    />
                  </div>
                </Col>
              ) }
            </Row>
          </>}
          { isNotEmptyAny(taskAnalysisDetail) && <MachineInfo
            detail={taskAnalysisDetail}
            isDemonstrate={isDemonstrate}
            onRefresh={methods.onRefresh}
            disabled={disabled}
          /> }
        </div>
      </div>
    </div>
  );
};

export default SpotDetailDrawerMain;
